import angular, {IScope} from 'angular';
import React from 'react';

import { UI_ROUTER_REACT_HYBRID } from '@uirouter/react-hybrid';
import { Transition, Rejection, RejectType } from '@uirouter/angularjs';
import { IRouteEspui, DeepLinkData } from './../src/global';

// Grunt exported module names are known after build version is added to file name

// @ts-expect-error dynamic grunt path
import ngLoadModules from '../dist_prod_ng/ngLoadModules.292.4.0.js';
// @ts-expect-error dynamic grunt path
import ngLoadApp from '../dist_prod_ng/ngLoadApp.292.4.0.js';
// @ts-expect-error dynamic grunt path
import ngLoadRoutes from '../dist_prod_ng/ngLoadRoutes.292.4.0.js';
import loadReactRoutes from './v2/routes';


// load Angular Modules, App code and routes
ngLoadModules(angular, UI_ROUTER_REACT_HYBRID);
ngLoadApp(angular);
const ngRoutes:object[] = ngLoadRoutes();
const reactRoutes:object[] = loadReactRoutes();

// espui app declaration
const espuiApp = angular.module('espui', [

	// router (must be first)
	UI_ROUTER_REACT_HYBRID,

	// grunt compiled html (*.tpl.html)
	'espui.templates',

	// core utils
	'espui.core',
	'espui.core.prefs',
	'espui.core.session',
	'espui.core.auth',
	'espui.core.ui',

	// shared
	'espui.shared',

	// workforce
	'espui.workforce',
	
	// home page
	'espui.main',
	'espui.login',
	'espui.home',
	'espui.about',

	// features
	'espui.ops',
	'espui.admin',
	'espui.invoice',
	'espui.orders',
	'espui.report'

]);
espuiApp.controller('espuiController', espuiController);
espuiApp.config(espuiConfig);
espuiApp.run(espuiRun);


/**
 * 	CONTROLLER
 */
 interface espuiController extends IScope {
	pageTitle: string;
	appVersion: string;
	skin: string;
	reactRefresh: number;
}

 espuiController.$inject = ['$window', '$location', '$transitions', '$state', '$rootScope', '$timeout', 'utilSvc', 'validSvc'];
 function espuiController(this: espuiController, $window, $location, $transitions, $state, $rootScope, $timeout, utilSvc, validSvc) {
	//console.log('APP CTL start: ' + window.location.href);
	var vm: espuiController = this as espuiController;

	// title
	vm.pageTitle = 'Verity 340B';
	vm.reactRefresh = 0;

	// get app version from index.html
	$rootScope.verityEspVersion = $window.verityEspVersion;
	vm.appVersion = $window.verityEspVersion;

	// show/hide message box (this used by the msgbox controller
	// note:    for layout, the msgbox visibility needs to be exposed on first index.html load
	//          but its visibility is inside the child scope
	$rootScope.vmAppShowMsgbox = false;

	// start rendering ui (as of sprint 47, force UI skin "B")
	vm.skin = $window.espuiPrefs.skin;

	// move table paging size to rootScope
	$rootScope.tblPagingSize = 50;


	/**
	 *    STATE CHANGE EVENT
	 *    update page title, send Google analytics
	 */
	 $transitions.onSuccess({}, function(trans:Transition) {
		// deprecated: $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
		const fromState:IRouteEspui = trans.from() || {name:''};
		const toState:IRouteEspui = trans.to() || { name: '' };
		//console.log('ROUTE SUCCESS, from: ' + fromState.name + ' to: ' + toState.name);

		// on bootstrap intial state is empty
		if (fromState.name === '') {
			return;
		}

		// home page start up needs to run before anything else
		if (!!!$rootScope.startUp && toState.name !== 'startup') {
			//console.log('ROUTE ISSUE $transitions.onSuccess, startup is false from: ' + fromState.name + ' go to startup');
			return $state.target('startup', {}, { reload: 'startup', inherit: false });
		}

		// check for page title on ui-route state
		if (!!toState.routeInfo && validSvc.isText(toState.routeInfo.title)) {
			vm.pageTitle = 'Verity 340B ' + toState.routeInfo.title;
		}
	});

	// REACT REFRESH
	// force Angular html render after React event (MsgBox is not rendering without an Angular controller property change)
	$rootScope.$on('react>refresh', function(){
		//console.log('APP CTL - REACT REFRESH: ' + vm.reactRefresh);
		vm.reactRefresh++;

		// setting a timeout forces an Angular refresh, its empty but we need it
		$timeout(function(){
			console.log('ng refresh');
		},100);
	});
}


/**
 * 	CONFIG
 */

espuiConfig.$inject = ['$stateProvider', '$urlRouterProvider', '$uiRouterProvider', '$locationProvider', '$provide'];
function espuiConfig($stateProvider, $urlRouterProvider, $uiRouterProvider, $locationProvider) {
	//console.log('APP CONFIG, href: ' + window.location.href);

	// load all NG routes in app level config
	var i:number = 0,
		rt:IRouteEspui;
	for(i=0; i < ngRoutes.length; i++) {
		rt = ngRoutes[i];
		try {
			$stateProvider.state(rt.name, rt);
		} catch (error:any) {
			throw new Error('ROUTE LOAD ERROR in App.ts for ' + rt.name + ': err: ' + error.message);
		}		
	}
	
	// load all react routes
	for(i=0; i < reactRoutes.length; i++) {
		$uiRouterProvider.stateRegistry.register(reactRoutes[i]);
	}
	
	
	/**
	 *    UI-ROUTER DEFAULTS
	 */
	$uiRouterProvider.urlService.rules.initial({ state: 'startup' });
	$urlRouterProvider.otherwise('/startup');
	$locationProvider.hashPrefix('');
	// route visualizer: $uiRouterProvider.plugin(Visualizer);


	/**
	 *    DEBUG ROOTSCOPE EVENTS
	 *    writes all events to console
	 * 	  turn this off when not debugging
	 *
	$provide.decorator('$rootScope', function ($delegate) {
	
		var _emit = $delegate.$emit;
		$delegate.$emit = function () {
			logEspuiEvents(arguments);
			_emit.apply(this, arguments);
		};
	
		return $delegate;
	
		function logEspuiEvents(args) {
	
			if(!!args) {
				for(i=0; i < args.length; i++) {
					if(typeof(args[i]) == 'string' && args[i].substring(0,6) == 'espui>') {
						if(args[i] != 'espui>msgbox.show') {
							console.log(args[i]);
						}
					}
				}
			}
	
		}
	
	});
	*/

}


/**
 * 	RUN
 */
espuiRun.$inject = ['$window', '$rootScope', '$transitions', '$state', '$timeout', 'sessionRepo', 'apiService', 'validSvc', 'utilSvc', 'msgSvc'];
function espuiRun($window, $rootScope, $transitions, $state, $timeout, sessionRepo, apiService, validSvc, utilSvc, msgSvc) {
	console.log('APP RUN, href: ' + window.location.href);
	//console.log('Routes: ' + angular.toJson($state.get()));

	var _stateParams = {},
		_pongRetryInterval = 1000 * 60 * 3, // 3 mins between pongs to server
		_pongNotify = false,
		_pongNotifyMins = 25; // after inactivity show expire message

	$rootScope.tabId = 't' + Date.now().toString();
	$rootScope.cobrand = 'verity'; // default

	/**
	 *    DEEP LINK
	 *    capture any url deep links before ui-router fires up
	 *    format is: url/#/feature/params
	 */

	// has deep link
	var hashIdx = $window.location.href.indexOf('#/');
	if (hashIdx > -1) {
		var hashTxt = $window.location.href.substr(hashIdx, 1000);

		// split up url
		var segments = hashTxt.split('/');
		if (Array.isArray(segments) && segments.length > 1) {

			// feature name
			var linkFeature = segments[1].toString().toLowerCase(),
				linkData = '';

			// params data
			if (segments.length > 2) {
				linkData = segments[2];
			}

			// find deep link feature by name
			var deepLinkData: DeepLinkData | null = null;
			switch (linkFeature) {

				case 'rxbilling':
					deepLinkData = {
						route: 'report.billing-rxdetail',
						params: {
							id: linkData
						}
					};
					break;

				case 'activate':
                case 'activatesso':
				case 'pwdreset':
				case 'newtab':
				case 'okta-return':
					//console.log('APP: deeplink data: ' + linkData);
					if (!!linkData) {
						$rootScope.tabId = linkData;
					}
					deepLinkData = {
						route: 'login',
						params: {
							reason: linkFeature,
							token: linkData
						}
					};

					// okta return token is in session
					if(linkFeature == 'okta-return') {
						console.log('DEEP LINK: get okta-return data');
						var oktaData = sessionRepo.get('okta-return');
						if(!!oktaData) {
							console.log('DEEP LINK: adding okta-return to login');
							deepLinkData.params.token = oktaData;
						}
					}
					break;

				case 'bdlanding':
                    // DEPRECATED during krogersso work
					// deepLinkData = {
					// 	route: 'home',
					// 	params: {
					// 		reason: 'uilanding',
					// 		client: 'bd'
					// 	}
					// };
					break;

				case '340b-express':
					$rootScope.cobrand = 'express';
					break;

				case 'verity':
					console.log('APP START: verity deep link, set verity_login local store');
					sessionRepo.setLocalStoreKey('verity_login', {ts:Date.now().toString()});
					break;
			}

			// feature found? save it
			if (!!deepLinkData) {
				//console.log('app run: found deep link, feature: ' + linkFeature + ' with data: ' + linkData);
				$rootScope.deepLink = deepLinkData;
				sessionRepo.set('deepLink', deepLinkData);
			}

		}

	}


	/**
	 *    PONG
	 */
	$rootScope.pongTimer = null;
	$rootScope.pongTimestamp = new Date();

	function pongStart(keepTimestamp: boolean = false) {
		pongStop();

		if (!!keepTimestamp) {
			//console.log('PONG start inactive: ' + utilSvc.dt.diffMinutes($rootScope.pongTimestamp, new Date()).toString() + ' mins');

			// notify user their session is getting old
			if (!_pongNotify && utilSvc.dt.diffMinutes($rootScope.pongTimestamp, new Date()) > _pongNotifyMins) {
				//console.log('PONG notify');
				_pongNotify = true;
				msgSvc.appTimeout().then(pongNotifyOK, pongNotifyOK);
			}

		}
		else {
			//console.log('PONG start new');
			$rootScope.pongTimestamp = new Date();
			_pongNotify = false;
		}

		$rootScope.pongTimer = $timeout(pongServer, _pongRetryInterval);
	}

	function pongStop() {
		if (!!$rootScope.pongTimer) {
			$timeout.cancel($rootScope.pongTimer);
			$rootScope.pongTimer = null;
		}
		//console.log('PONG stop');
	}

	function pongServer() {

		// re-check session token with the server

		// user session is valid (they are logged in)
		if (!!$rootScope.startUp && !!$rootScope.User) {

			// last activity was > 3 mins ago?
			if (utilSvc.dt.diffMilli($rootScope.pongTimestamp, new Date()) > _pongRetryInterval) {
				//console.log('PONG CHECK, ask server, seconds: ' + utilSvc.dt.diffSeconds($rootScope.pongTimestamp, new Date()));
				pongStop();
				apiService.pong().then(okPong, errPong);
			}
			else {
				//console.log('PONG CHECK OK');
				pongStart(true);
			}

		}
		else {
			//console.log('PONG CHECK USER NO GOOD');
			pongStop();
		}

		function okPong() {
			// session on server is still good
			if (!!$rootScope.startUp && !!$rootScope.User) {
				//console.log('PONG: server says OK');

				// notify features pong is good
				$rootScope.$emit('espui>pong', {});

				pongStart(true);
			}
		}

		function errPong() {
			// any pong error is an immediate logout
			//console.log('PONG: server says NO GOOD');
			$rootScope.$emit('espui>auth.logout', { reason: 'timeout' });
		}

	}

	function pongNotifyOK(r) {

		// note: if the app times out it will return this as a cancel

		// user clicked OK before timeout
		if (!!r && r.result == 'OK') {
			//console.log('PING PONG calling server');
			apiService.post('security/ping', {}).then(okPingPong, errPingPong);
		}

		function okPingPong() {
			//console.log('PING PONG OK');
			// token is ok, reset pong
			pongStart();
		}

		function errPingPong(r) {
			if (r !== null) {
				// extremely unlikely, any ping error should have been handled by apiService as a 401
				throw new Error('appMainCtl.errPingPong, unexpected api error: ' + utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    ROUTE CHANGE EVENTS
	 *    verity app start up and valid user on all state changes
	 */

	// ROUTE ON START
	$transitions.onStart({}, function(trans:Transition) {
		// deprecated: $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams)

		const fromState:IRouteEspui = trans.from() || {name:''};
		const toState:IRouteEspui = trans.to() || { name: '' };
		//console.log('ROUTE START, from: ' + fromState.name + ' to: ' + toState.name);

		// home page start up needs to run before anything else
		if (!!!$rootScope.startUp && toState.name !== 'startup') {
			//console.log('ROUTE: $transitions.onStart, startUp is false, STATE FROM: ' + fromState.name + ', go to startup');
			return $state.target('startup',{}, { reload: 'startup', inherit: false });
		}

		// authorize all state changes
		// note: only startup and login routes a skipAuth = true property
		if (!!!toState.skipAuth && !!!$rootScope.User) {
			//console.log('ROUTE: $transitions.onStart, user auth failed, STATE FROM: ' + fromState.name + ', go to login');
			return $state.target('login', {}, { reload: 'login' });
		}

		// cache state params (back button fix)
		if (!!toState.params) {
			const toParams = toState.params;

			// check if all toParams are null
			var routeHasData = false;
			for (var prop in toParams) {
				if (toParams.hasOwnProperty(prop) && toParams[prop] !== null) {
					routeHasData = true;
					break;
				}
			}

			toState.name = !!toState.name ? toState.name : '';
			const stateKeyName:string = toState.name.replace(/\./g, '-');

			if (routeHasData) {
				// toParams have values, update params cache for this route
				_stateParams[stateKeyName] = toParams;
			}
			else if (!!_stateParams[stateKeyName]) {
				// toParams are all null
				/*
					route params cache is a fix for user clicking browser back/fwd button
					if toState.params are defined but toParams are all null, use previous values
				 */
				return $state.target(toState.name, _stateParams[stateKeyName], { reload: toState.name });
			}
		}
	});

	// ROUTE ON ERROR
	$transitions.onError({}, function(trans:Transition) {
		// deprecated: $rootScope.$on("$stateChangeError", function (event, toState, toParams, fromState, fromParams, err) {

		// catch HTTP errors in route methods
		// note: by default ui-router silently fails on HTTP errors

		// clear state cache
		_stateParams = {};
		//console.log('ROUTE TRANS ERROR: ' + trans.error());

		// deal with specific transition errors only
		const err:Rejection = trans.error();
		if(err.type == RejectType.ERROR || err.type == RejectType.INVALID) {
			var newError:Error;
			const fromState:IRouteEspui = trans.from() || {name:''};
			const toState:IRouteEspui = trans.to() || { name: '' };
			//console.log('ROUTE ERROR (type ' + err.type.toString() + '), from: ' + fromState.name + ' to: ' + toState.name);

			// http connection error?
			if(err.type == RejectType.ERROR && !!err.detail && validSvc.isInteger(err.detail.status)) {
				const errStatus = err.detail.status;
				//console.log('checking for http error: ' + err.message + err.detail);
				if (errStatus === -1 || errStatus === 0 || errStatus === 502 || errStatus === 404) {
					newError = new Error('Server Connection Issue routing from : ' + fromState.name + ' to: ' + toState.name + ' (' + errStatus + ') ' + utilSvc.http.safeResponse(err));
					newError.name = 'TRANSITIONERROR';
					throw newError;
				}
			}
			else if(err.type == RejectType.INVALID) {
				newError = new Error('Invalid Route from: ' + fromState.name + ' to: ' + toState.name + '. Error: ' + utilSvc.http.safeResponse(err));
				newError.name = 'TRANSITIONERROR';
				throw newError;
			}
	
			// unknown
			newError = new Error('Unknown routing error from: ' + fromState.name + ' to: ' + toState.name + '. Error: ' + utilSvc.http.safeResponse(err));
			newError.name = 'TRANSITIONERROR';
			throw newError;
		}
	});

	// ROUTE GENERIC ERROR HANDLER
	$state.defaultErrorHandler(function(err) {
		//console.log('ROUTE GENERIC ERROR: ' + err);
		if(!!err && !validSvc.isInteger(err.type)) {
			// this is not a transition hook error, throw it
			throw new Error('Unknown routing generic error' + utilSvc.http.safeResponse(err));
		}
		else if(!!!err) {
			// this should never happen!
			throw new Error('Unknown routing generic error with no description for url: ' + window.location.href);
		}
	});


	/**
	 *    CONTEXT CHANGE EVENT
	 *    save the user CE, RX dropdown choices across features
	 */

	$rootScope.$on('espui>context.change', function (event, data) {

		// user has changed CE or RX, remember their last selection

		var newCeValid = validSvc.isCE(data.CE, true),
			newRxValid = validSvc.isRX(data.RX, true);

		// nothing to update
		if (!newCeValid && !newRxValid) {
			return;
		}

		var changed = false;

		// CE
		if (newCeValid && $rootScope.User.CE != data.CE) {
			$rootScope.User.CE = data.CE;
			changed = true;
		}
		else if (!validSvc.isCE($rootScope.User.CE)) {
			$rootScope.User.CE = 'NONE';
			changed = true;
		}

		// RX
		if (newRxValid && $rootScope.User.RX != data.RX) {
			$rootScope.User.RX = data.RX;
			changed = true;
		}
		else if (!validSvc.isRX($rootScope.User.RX)) {
			$rootScope.User.RX = 'NONE';
			changed = true;
		}

		// update session
		if (changed) {
			sessionRepo.set('User', $rootScope.User);
		}

	});


	/**
	 *    EVENT: STARTUP
	 *    startup controller fires this event when done
	 *    app will check the user token and send to login or home
	 */

	$rootScope.$on('espui>startup', function () {
		console.log('APP EVENT: startup, window name: ' + $window.name);
		// clear state cache
		_stateParams = {};

		// setup window name / tab id
		// note: if window already has a name this is a refresh, app update, etc
		var hasWindowName = validSvc.isText($window.name);
		if(hasWindowName) {
			$rootScope.tabId = $window.name;
		}
		else {
			// use tab id for window name its empty
			$window.name = $rootScope.tabId;
		}
		//console.log('EVENT: STARTUP, has window name: ' + hasWindowName);

		// pre-login deep link token on url (activate / pwdreset / newtab)
		var dlToken = $rootScope.deepLink || sessionRepo.get('deepLink');
		if (!!dlToken && dlToken.route == 'login' && !!dlToken.params && (dlToken.params.reason == 'activate' || dlToken.params.reason == 'activatesso' || dlToken.params.reason == 'pwdreset' || dlToken.params.reason == 'newtab' || dlToken.params.reason == 'okta-return')) {
			// clear User state and load pre-login deep link
			clearLoginState(true);
			
			//console.log('APP AFTER START EVENT: deep link params: ' + JSON.stringify(dlToken.params));
			$rootScope.deepLink = null;

			$state.go('login', dlToken.params, {reload:'login'});
			return;
		}
		
		// already has token, could be a refresh or duplicate tab
		if(validSvc.isText(sessionRepo.get('token'))) {
			//console.log('EVENT: STARTUP, has token');

			var tabs = sessionRepo.getLocalStoreKey('tabs');
			var tablist = !!tabs && Array.isArray(tabs.list) ? tabs.list : [];
			//console.log('EVENT: STARTUP, tab list length: ' + tablist.length.toString());

			// refresh, find the tab id
			var foundRefreshTabId = false;
			if(hasWindowName) {
				for(var itab = 0; itab < tablist.length; itab++) {
					if(tablist[itab].id == $rootScope.tabId) {
						//console.log('EVENT: STARTUP, found refresh tab id: ' + $rootScope.tabId);
						foundRefreshTabId = true;
						break;
					}
				}
			}

			// ok to use token for refresh or duplicate
			if((hasWindowName && foundRefreshTabId) || tablist.length < 5) {
				console.log('APP EVENT: STARTUP, try user token');
				apiService.refreshUser(true).then(okUserRefresh, errUserRefresh); //calls security/login/refresh
				return;
			}

			// cannot use token, notify user they cannot exceed max 5 tabs
			$rootScope.$emit('espui>auth.tabmax');
			return;
		}

		// regular start up, goto login
		clearLoginState(true);
		var loginState = !!sessionRepo.getLocalStoreKey('verity_login') ? 'verity.login' : 'login';
		$state.go(loginState, {}, { reload: loginState });


		function okUserRefresh() {

			// re-validate user after refresh
			$rootScope.User = validateUser();
			$rootScope.$emit('espui>auth.change', {});

			// token is valid but User still invalid, return to login
			if ($rootScope.User === null) {
				clearLoginState(false);
				$state.go('login', {}, { reload: 'login' });
				return;
			}

			pongStart();

			checkDeepLinkAfterLogin();

		}

		function errUserRefresh(r) {

			if (!!r) {
				// extremely unlikely, any session token issues should have been handled by apiService as a 401 or silent fail
				throw new Error('appMainCtl.errPing, unexpected api error: ' + utilSvc.http.safeResponse(r));
			}
			else {
				// silent app startup error, return to login
				$rootScope.$emit('espui>auth.logout', {});
			}
		}

	});


	/**
	 *    EVENT: LOGIN
	 *    fired by login controller after pwd expiration and tou are checked
	 */

	$rootScope.$on('espui>auth.login', function () {
		//console.log('EVENT: auth.login');
		// clear state cache
		_stateParams = {};

		// check user valid and last time start up was run > 10 mins
		$rootScope.User = validateUser();
		if (!!!$rootScope.User || !!!$rootScope.startUp || !validSvc.isDate($rootScope.startUpTimestamp) || utilSvc.dt.diffSeconds($rootScope.startUpTimestamp, new Date()) > 600) {

			// clear User and startUp but keep session token and deep link
			pongStop();
			sessionRepo.set('User', null);
			$rootScope.User = null;
			$rootScope.startUp = false;
			$rootScope.$emit('espui>auth.change', {});

			$state.go('startup', {}, { reload: 'startup', inherit: false });
			return;
		}

		// login good
		pongStart();
		$rootScope.$emit('espui>auth.change', {});

		checkDeepLinkAfterLogin();

	});

    /**
     *    EVENT: TABMAX
     *    called by header to shut down an extra tab above max
     */
	$rootScope.$on('espui>auth.tabmax', function () {
		clearLoginState(true);
		$state.go('login', {reason:'tabmax'}, {reload:'login'});
	});

	/**
	 *    EVENT: LOGOUT
	 *    called by apiService on any 401 status, or by authService if user clicks logout
	 */

	// ts-expect-error need param to use data param	
	$rootScope.$on('espui>auth.logout', function (event, data) {
		//console.log('EVENT: auth.logout');
		// clear state cache
		_stateParams = {};
		data = data || { reason: '', token:'' };

		// clear ui user state and forget deep link
		clearLoginState(true);
		$rootScope.deepLink = null;

		// clear local store between users
		if(!!$rootScope.debug) {
			// debug mode
			sessionRepo.removeLocalStoreKey('tabs');
			sessionRepo.removeLocalStoreKey('apilog');
			sessionRepo.removeLocalStoreKey('user_review_seen');
		}
		else {
			// always keep verity login and rem token state
			var verityLogin = sessionRepo.getLocalStoreKey('verity_login'),
				rem = sessionRepo.getLocalStoreKey('rem340b');
			sessionRepo.clearLocalStore();

			// put back verity and/or rem token
			if(verityLogin) {
				sessionRepo.setLocalStoreKey('verity_login', {ts:Date.now().toString()});
			}
			if(validSvc.isText(rem)) {
				sessionRepo.setLocalStoreKey('rem340b', rem);
			}
		}

		// expire start up time to force start up check after next login
		$rootScope.startUpTimestamp = new Date(2000, 1, 1);

		// go to login page (unless startup or login are cleaning up user session)
		if (data.reason != 'startup' && data.reason != 'login_cleanup') {
			$state.go('login', { reason: data.reason, token:data.token }, { reload: 'login' });
		}

	});


	/**
	 *    EVENT: CLEAR ROUTE PARAM DATA
	 *    called by features to reset their incoming state params
	 */

	// ts-expect-error need param to use data param
	$rootScope.$on('espui>route.reset', function (event, data) {
		//console.log('EVENT: route.reset');

		if (!!_stateParams && typeof (data.route) === 'string') {
			var stateKeyName = data.route.replace(/\./g, '-');
			if (stateKeyName.length > 0 && !!_stateParams[stateKeyName]) {
				_stateParams[stateKeyName] = null;
			}
		}

	});


	/**
	 *    EVENT: COBRAND
	 *    registration, pwd reset and login fire this event to update cobrand
	 */

	// ts-expect-error need param to use data param
	$rootScope.$on('espui>cobrand', function (event, brand) {
		//console.log('APP EVENT: cobrand: ' + brand);
		$rootScope.cobrand = brand;
	});


	/**
	 * 	EVENT: REACT ERROR OR WARNING
	 * 	intermediary to log React delegate errors or warnings
	 */
	// ts-expect-error need param to use data param
	$rootScope.$on('react>error-warning', function (event, data) {
		//console.log('APP EVENT: react error: ' + data.msg);
		$rootScope.$emit('espui>error', data);
		$rootScope.$emit('react>refresh');
	});


	/**
	 * 	EVENT: REACT PONG TIMER
	 * 	React sends user activity updates to reset Angular inactivity timestamp
	 */
	 $rootScope.$on('react>pong-timer', function () {
		//console.log('APP EVENT: react activity for action: ' + data.action);
		$rootScope.pongTimestamp = new Date();
		$rootScope.$emit('react>refresh');
	});


	/**
	 * 	EVENT: REACT ROOTSCOPE UPDATE
	 * 	React sends props to update on Angular rootScope
	 */
	$rootScope.$on('react>rootscope-update', function (event, data) {
		data = data || {};
		console.log('APP EVENT: react root update for prop: ' + data.prop);
		if(!validSvc.isText(data.prop)) {
			return;
		}
		
		// only certain props can be updated
		switch(data.prop) {
			case 'apiLog':
				$rootScope.apiLog = data.val;
				break;
			default:
				console.log('APP EVT: react>rootscope-update, unknown prop: ' + data.prop);
				return;
		}
		$rootScope.$emit('react>refresh');
	});
	
	/**
	 *    HELPERS
	 */

	function validateUser() {

		// check session for a valid user

		if (sessionRepo.valid()) {
			var user = sessionRepo.get('User');
			if (!!!user || !validSvc.isInteger(user.PwdDaysToExpire) || user.PwdDaysToExpire < 1 || !!user.TwoFactor || !!!user.Tou || !!!user.IpValid) {
				return null;
			}

			// user is ok
			return user;
		}

		return null;

	}

	function clearLoginState(resetMenu) {

		// clear everyting setup after login
		sessionRepo.clear();
		pongStop();
		$rootScope.User = null;

		if (!!resetMenu) {
			$rootScope.$emit('espui>auth.change', {});
		}

	}

	function checkDeepLinkAfterLogin() {

		// once login is finsihed, check for post-login routes

		var dl = $rootScope.deepLink || sessionRepo.get('deepLink');
		if (!!dl && !!dl.route && !!dl.params) {

			// ui landing mode?
			if (dl.params.reason == 'uilanding') {
				$rootScope.$emit('espui>uilanding', { on: false });
			}

			// forget deep link
			$rootScope.deepLink = null;
			sessionRepo.set('deepLink', null);

			$state.go(dl.route, dl.params);
		}
		else {
			$state.go('home', {}, { reload: 'home' });
		}

	}

}

espuiApp.component('angularComponent', {
	template: `
    <h1>Hello from angularjs</h1> 
    <h3>{{$ctrl.$state$.name}} state loaded</h3>
    <a ui-sref="react" ui-sref-active-eq="active">react feature</a>
    <p>&nbsp;</p>
    <a ui-sref="angular.reactchild" ui-sref-active-eq="active">react child</a>
    <ui-view></ui-view>
  `,
	bindings: { $state$: '<' },
});


/**
 * 	BOOTSTRAP ANGULAR
 */
const root = document.getElementById('root');
if (!!root) {
	angular.bootstrap(root, ['espui']);
}
